import {
  createLookupCombiner,
  createLookupSelectors,
  objectMapper,
} from "selectors/lib";
import { selectBusinessRelationIdsByBusinessIdLookup } from "selectors/indexes";
import { getBusinessRelations } from "selectors/root";

export const getBusinessRelationById = relationId => state =>
  getBusinessRelations(state)[relationId] || null;

export const [
  selectBusinessRelationsByBusinessIdLookup,
  getBusinessRelationsByBusinessId,
] = createLookupSelectors(
  [selectBusinessRelationIdsByBusinessIdLookup, getBusinessRelations],
  createLookupCombiner(objectMapper),
);
